<template>
  <div class="salaries-content-group-trends">
    <SalariesContentGroupHeader group-id="trends" />
    <SalariesContentBlock group-id="trends">
      <h3 slot="header" class="salaries-content-group-trends__header">
        39% of sales professionals
        <br />
        will not return to an office
      </h3>
      <div slot="description2" class="salaries-content-group-trends__description2">
        By providing employees the option to work from home, employers
        <br />
        open themselves up to a wider group of top talent.
      </div>
      <div slot="table" class="salaries-content-group-trends__table">
        <div class="salaries-content-group-trends__table-col">
          <div class="salaries-content-group-trends__table-col-inner">
            <div class="salaries-content-group-trends__table-img-wrapper">
              <img
                loading="lazy"
                class="salaries-content-group-trends__table-img-1"
                src="./images/content-14.png"
                srcset="./images/content-14.png, ./images/content-14@2x.png 2x"
                alt="REMOTE WORK TRENDS - 39% of sales professionals will not return to an office"
              />
            </div>
          </div>
          <div class="salaries-content-group-trends__table-col-inner">
            <Content14LabelsSvg class="salaries-content-group-trends__table-labels" />
          </div>
        </div>
      </div>
    </SalariesContentBlock>
    <SalariesContentBlock group-id="trends">
      <h3 slot="header" class="salaries-content-group-trends__header">
        54% of job seekers are
        <br />
        willing to relocate
        <br />
        for a great job
      </h3>
      <div slot="description2" class="salaries-content-group-trends__description2">
        Respondents indicated whether or not they would be willing to relocate
        <br />
        for a new job.
        <br class="keep" />
        <br />
        Despite what you may think, the majority of candidates are willing to
        <br />
        relocate for an amazing job opportunity.
      </div>
      <div slot="table" class="salaries-content-group-trends__table">
        <div class="salaries-content-group-trends__table-col">
          <div class="salaries-content-group-trends__table-col-inner">
            <div class="salaries-content-group-trends__table-img-wrapper">
              <img
                loading="lazy"
                class="salaries-content-group-trends__table-img-2"
                src="./images/content-15.png"
                srcset="./images/content-15.png, ./images/content-15@2x.png 2x"
                alt="REMOTE WORK TRENDS - 54% of job seekers are willing to relocate for a great job"
              />
            </div>
          </div>
          <div class="salaries-content-group-trends__table-col-inner">
            <Content15LabelsSvg class="salaries-content-group-trends__table-labels" />
          </div>
        </div>
      </div>
    </SalariesContentBlock>
  </div>
</template>

<script>
import SalariesContentGroupHeader from './SalariesContentGroupHeader.vue';
import SalariesContentBlock from './SalariesContentBlock.vue';
import Content14LabelsSvg from './images/content-14-labels.vue.svg';
import Content15LabelsSvg from './images/content-15-labels.vue.svg';

export default {
  name: 'SalariesContentGroupTrends',
  components: {
    SalariesContentBlock,
    SalariesContentGroupHeader,
    Content14LabelsSvg,
    Content15LabelsSvg,
  },
};
</script>

<style lang="scss" scoped>
.salaries-content-group-trends {
  &__header {
    background: linear-gradient(86.98deg, #1b447f -13.55%, #5f86d1 110.07%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 8px;
  }

  &__description2 {
    margin-bottom: 32px;
  }

  &__table {
    display: flex;
    justify-content: space-between;
  }

  &__table-col {
    &:first-child {
      flex-grow: 1;
      display: flex;
      justify-content: space-between;
      flex-direction: column;

      @include mq('sm') {
        flex-direction: row;
      }
    }

    & + &:last-child {
      margin-left: 71px;
      flex-shrink: 0;
      flex-basis: 361px;
    }
  }

  &__table-img {
    border-radius: 16px;
    overflow: hidden;
    filter: drop-shadow(0 34px 56px rgba(0, 0, 0, 0.12));
  }

  &__table-text-header {
    font-weight: 600;
    font-size: 22px;
    line-height: 28px;
    letter-spacing: -0.5px;
    margin-bottom: 8px;
    background: linear-gradient(87.2deg, #1b447f -9.58%, #5f86d1 104.83%), linear-gradient(0deg, #fff, #fff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  &__table-text + &__table-text-header {
    margin-top: 32px;
  }

  &__table-text {
    font-size: 16px;
    line-height: 30px;
    color: #45454a;
  }

  &__table-img-1 {
    width: 320px;
    height: 335px;
    position: relative;

    @include mq('md') {
      width: 460px;
      height: 482px;
      left: -49px;
      top: -14px;
    }
  }

  &__table-img-2 {
    width: 320px;
    height: 320px;
    position: relative;

    @include mq('md') {
      width: 460px;
      height: 460px;
      left: -49px;
      top: -14px;
    }
  }

  &__table-col-inner {
    display: flex;

    @include mq('md') {
      align-items: center;
    }
  }

  &__table-labels {
    @include mq('md') {
      margin-left: 67px;
    }
  }

  &__table-img-wrapper {
    height: 320px;
    position: relative;
    width: calc(100vw - 24px - 24px);
    display: flex;
    justify-content: center;

    @include mq('sm') {
      width: 320px;
      display: block;
    }

    @include mq('md') {
      width: 360px;
      height: 360px;
    }
  }
}
</style>
